import React from "react";
import NoDataIcon from "../images/NoDataIcon";

function NoSearchitems() {
  return (
    <div className="h-full w-full flex items-center justify-center">
      <div className="flex flex-col justify-center items-center">
        {/* <p className="text-[#999999] text-lg mb-2">
No Order Created
</p> */}
        <NoDataIcon />
        <p className=" text-[#8a8a8a]">No items found</p>

        {/* <p
className="finsire-bg-blue text-white text-center px-4 py-2 rounded cursor-pointer"
onClick={() => setShowCreateOrder(true)}
>
Create Order
</p> */}
      </div>
    </div>
  );
}

export default NoSearchitems;
